import axios from 'axios';
import { ApiError } from '../../../types/api-error';

export function mapToApiError(error: unknown): ApiError {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: string } | undefined;
    return {
      status: error.response?.status,
      message: data?.message ?? error.message ?? "Request failed.",
      details: error.response?.data,
    }
  }
  if (error instanceof Error) {
    return {
      message: error.message,
    }
  }

  return {
     message: "Unknown error",
  }
}